import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Container, Row, Col, Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import ClientesTable from '../components/Clientes/ClientesTable';
import ClienteModal from '../components/Clientes/ClienteModal';
import useClientes from '../components/Clientes/useClientes';
import { actualizarDatos, getDataList } from '../api/common';
import { adminCreate } from '../api/user';

export const Clientes = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUsuario, setSelectedUsuario] = useState(null);
  const [clienteRoleId, setClienteRoleId] = useState(null);
  const tableRef = useRef(null);

  useEffect(() => {
    getDataList('Roles', {}).then((res) => {
      const roles = res.data?.data || [];
      const clienteRole = roles.find((r) => r.nombre === 'Cliente');
      if (clienteRole) setClienteRoleId(clienteRole._id);
    }).catch(() => {});
  }, []);

  const {
    syncMasivaLoading,
    syncIndividualLoading,
    handleSyncMasiva,
    handleSyncIndividual,
  } = useClientes();

  const refresh = useCallback(() => {
    tableRef.current?.refresh();
  }, []);

  const handleEdit = (usuario) => {
    setSelectedUsuario(usuario);
    setShowModal(true);
  };

  const handleCreate = () => {
    setSelectedUsuario(null);
    setShowModal(true);
  };

  const handleDelete = async (usuario) => {
    const confirm = await Swal.fire({
      title: '¿Eliminar cliente?',
      text: `Se eliminará a ${usuario.nombre || usuario.identificacion}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (!confirm.isConfirmed) return;

    try {
      await actualizarDatos('Usuarios', usuario._id, { status: 'eliminado' });
      Swal.fire('Eliminado', 'Cliente eliminado correctamente', 'success');
      refresh();
    } catch (err) {
      Swal.fire('Error', err.message, 'error');
    }
  };

  const handleSave = async (formData) => {
    try {
      if (selectedUsuario?._id) {
        await actualizarDatos('Usuarios', formData, selectedUsuario._id);

        // Cascade: actualizar la sede Principal con los datos base del cliente
        try {
          const sedesRes = await getDataList('Sedes', { conditions: { cliente: selectedUsuario._id, nameSede: 'Principal' } });
          const sedes = sedesRes.data?.data || [];
          if (sedes.length > 0) {
            const principal = sedes[0];
            await actualizarDatos('Sedes', {
              ...principal,
              dirSede: formData.direccion ?? principal.dirSede,
              ciudad: formData.ciudad ?? principal.ciudad,
              departamento: formData.departamento ?? principal.departamento,
              celContacto: formData.telefono ?? principal.celContacto,
              contSede: formData.contacto ?? principal.contSede,
            }, principal._id);
          }
        } catch (_) {
          // No bloquear si falla cascade
        }

        Swal.fire({ title: 'Cliente actualizado', icon: 'success', toast: true, position: 'top-end', timer: 2000, showConfirmButton: false });
      } else {
        await adminCreate({ ...formData, password: formData.identificacion });
        Swal.fire({ title: 'Cliente creado', icon: 'success', toast: true, position: 'top-end', timer: 2000, showConfirmButton: false });
      }
      setShowModal(false);
      refresh();
    } catch (err) {
      const msg = err.response?.data?.detail || err.response?.data?.error?.message || err.response?.data?.message || err.message;
      Swal.fire('Error', msg, 'error');
    }
  };

  return (
    <Container fluid className="py-3">
      <Row className="mb-3 align-items-center">
        <Col>
          <h4 className="mb-0">Clientes</h4>
        </Col>
        <Col xs="auto" className="d-flex gap-2">
          <Button variant="primary" onClick={handleCreate}>
            + Agregar Cliente
          </Button>
          <Button
            variant="outline-success"
            onClick={() => handleSyncMasiva(refresh)}
            disabled={syncMasivaLoading}
          >
            {syncMasivaLoading ? (
              <><Spinner animation="border" size="sm" className="me-1" /> Sincronizando...</>
            ) : (
              'Sincronizar desde contabilidad ↓'
            )}
          </Button>
        </Col>
      </Row>

      {clienteRoleId ? (
        <ClientesTable
          ref={tableRef}
          roleId={clienteRoleId}
          onSyncIndividual={(id) => handleSyncIndividual(id, refresh)}
          syncIndividualLoading={syncIndividualLoading}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ) : (
        <div className="text-center py-4"><Spinner animation="border" size="sm" /> Cargando...</div>
      )}

      <ClienteModal
        show={showModal}
        onHide={() => setShowModal(false)}
        usuario={selectedUsuario}
        onSave={handleSave}
      />
    </Container>
  );
};
